export const Youtube = () => {
  return (
    <svg height={512} viewBox="0 0 24 24" width={512}>
      <title>Youtube</title>
      <path
        fill="currentColor"
        d="M23.469 5.929l.03.196a3.043 3.043 0 00-2.068-2.112l-.021-.005c-1.871-.508-9.4-.508-9.4-.508s-7.51-.01-9.4.508A3.044 3.044 0 00.527 6.104l-.005.021c-.699 3.651-.704 8.038.031 11.947l-.031-.198a3.043 3.043 0 002.068 2.112l.021.005c1.869.509 9.4.509 9.4.509s7.509 0 9.4-.509a3.043 3.043 0 002.084-2.096l.005-.021c.318-1.698.5-3.652.5-5.648l-.001-.221.001-.23c0-1.997-.182-3.951-.531-5.846zM9.608 15.651V8.358l6.266 3.652z"
      />
    </svg>
  )
}
